<template>
  <!-- 表格弹框 -->
  <div v-if="visible" class="modal">
    <i class="close-icon el-icon-close" @click="dialogClose" />
    <!-- 表格内容 -->
    <table class="table">
      <!-- 表格行和单元格 -->
      <tr class="gray-row">
        <td class="centered-cell">{{ $t('SeaExport.ChargeSource') }}</td>
        <td class="centered-cell">{{ $t('SeaExport.Quantity') }}</td>
        <td class="centered-cell">{{ $t('SeaExport.Weight') }}</td>
      </tr>
      <tr>
        <td class="centered-cell">{{ $t('CargoMsg.Local') }}</td>
        <td class="centered-cell">{{ data.localQuantity }}</td>
        <td class="centered-cell">{{ data.localWeight }}</td>
      </tr>
      <tr>
        <td class="centered-cell">{{ $t('CargoMsg.CustomsDocumentPreparation') }}</td>
        <td :class="qualityDiff ? 'centered-cell red-text' : 'centered-cell'">{{ data.customsQuantity }}</td>
        <td :class="weightDiff ? 'centered-cell red-text' : 'centered-cell'">{{ data.customsWeight }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'InformationComparisonDialog',
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Object, default: null }
  },
  data() {
    return {
      qualityDiff: false,
      weightDiff: false
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.onShow()
      }
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {
      this.qualityDiff = !(this.data.localQuantity === this.data.customsQuantity)
      this.weightDiff = !(this.data.localWeight === this.data.customsWeight)
    }
  }
}
</script>

<style scoped>
.modal {
  width: 300px;
  height: 100px;
  position: fixed;
  bottom: 20px;
  right: 30px;
  background-color: white;
  padding: 0px;
  border: 1px solid #ccc;
}

.table {
  border-collapse: collapse; /* 合并边框 */
  width: 100%;
}

td {
  border: 1px solid #ccc;
  padding: 2px;
}
.gray-row {
  background-color: #f2f2f2; /* 灰色背景 */
}
.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.centered-cell {
  text-align: center; /* 文字居中对齐 */
}
.red-text {
  color: red; /* 设置文字颜色为红色 */
}
</style>
